export const nowrap = (str) => {
    return str.replace(/\s/g, '\u00a0').replace('-', '\u2011');
};
